
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 56 54","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M47.05 20.907l-2.364 2.364c-.469.47-.469 1.223 0 1.672.224.224.53.346.836.346.306 0 .611-.122.836-.346l2.364-2.365c.47-.469.47-1.223 0-1.671a1.187 1.187 0 00-1.671 0z"}}),_c('path',{attrs:{"d":"M55.388 19.459l-3.424-3.425c-.694-.693-1.794-.734-2.61-.163a7.193 7.193 0 01-1.468.285c.286-.347.428-.775.47-1.223a2.041 2.041 0 00-.592-1.53l-8.603-8.54C36.491 2.191 29.233.192 27.745.01a1.175 1.175 0 00-1.305.918l-.733 3.363c-.082.327 0 .673.183.938.183.265.469.428.775.49.917.264 4.525 2.609 5.769 4.199l-3.18 3.18a2.262 2.262 0 00-.653 1.427c-.02.57.184 1.121.571 1.53l1.672 1.67L.367 46.716A1.22 1.22 0 000 47.57c0 .326.122.632.347.856l5.198 5.198c.224.224.53.347.836.347h.02c.326 0 .632-.143.856-.367l29.01-30.518.937.938c.388.408.958.612 1.53.57.448-.02.876-.183 1.222-.448a6.827 6.827 0 01-.265 1.468 2.012 2.012 0 00.163 2.61l3.425 3.424c.367.367.856.571 1.366.571h.102c.51-.02.999-.245 1.386-.611l9.255-9.256A2.07 2.07 0 0056 20.967c-.02-.591-.224-1.121-.612-1.508zM6.36 51.076l-3.465-3.466 29.661-28.214 1.998 1.998L6.36 51.077zm38.265-21.426l-2.875-2.874c.041-.061.061-.122.082-.183.122-.327 1.141-3.303-.163-5.464a1.193 1.193 0 00-.877-.57 1.153 1.153 0 00-.978.346l-1.183 1.182-7.502-7.502 3.65-3.649c.325-.326.427-.815.264-1.264-.754-1.998-4.627-4.77-6.809-5.85l.286-1.244c2.446.612 7.318 2.304 8.97 3.955l8.358 8.297-1.182 1.182a1.175 1.175 0 00-.347.979c.04.367.244.693.57.876 2.162 1.305 5.138.286 5.464.164a.724.724 0 00.184-.082l2.874 2.874-8.786 8.827z"}})])
          )
        }
      }
    